import {getObituaryData, postObituaryData} from "../api/api";

// SET_PEOPLE_TO_INFORM
export const setPeopleToInform = (peopleToInformData) => ({
    type: 'SET_PEOPLE_TO_INFORM',
    data: peopleToInformData
});


export const starSetPeopleToInform = (peopleToInformData = {}) => {
    return (dispatch) => {
        dispatch(setPeopleToInform(peopleToInformData))
    }
};

// SET_ORGANIZATION_TO_CONTACT
export const setOrganizationToContact = (organizationToContactData) => ({
    type: 'SET_ORGANIZATION_TO_CONTACT',
    data: organizationToContactData
});


export const starSetOrganizationToContact = (organizationToContactData = {}) => {
    return (dispatch) => {
        dispatch(setOrganizationToContact(organizationToContactData))
    }
};


// SET_OBITUARY
export const setObituary = (obituaryData) => ({
    type: 'SET_OBITUARY',
    data: obituaryData
});


export const starSetObituary = (obituaryData = {}) => {
    return (dispatch) => {
        dispatch(setObituary(obituaryData))
    }
};

export const createObituary = (obituaryData = {}, idPartner = '') => {
    return () => {
        return postObituaryData(obituaryData, idPartner)
    }

};

// GET_OBITUARY
export const getObituary = (obituaryData) => ({
    type: 'GET_OBITUARY',
    data: obituaryData
});

export const starGetObituary = (idBenef = '', idPartner = '') => {
    return () => {
        return getObituaryData(idBenef, idPartner) ;
    }
};


// WEBPACK FOOTER //
// ./src/actions/obituary.js